class LogoMarqueeViewport extends HTMLElement {
  #resizeObserver = null;

  connectedCallback() {
    this.#resizeObserver = new ResizeObserver(() => {
      this.#layout();
    });
    this.#resizeObserver.observe(this);

    this.#layout();
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
  }

  #layout = () => {
    const track = this.querySelector('.logo-marquee__track');
    const sourceGroup = this.querySelector('.logo-marquee__group:not(.logo-marquee__group--duplicate)');

    if (!track || !sourceGroup) {
      return;
    }

    this.#clearDynamicClones();

    const viewportWidth = this.clientWidth;
    let groupWidth = sourceGroup.getBoundingClientRect().width;

    if (!groupWidth) {
      return;
    }

    const minTrackWidth = Math.max(viewportWidth * 2, groupWidth * 2);

    while (track.scrollWidth < minTrackWidth) {
      const clone = sourceGroup.cloneNode(true);
      clone.classList.add('logo-marquee__group--duplicate');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.setAttribute('data-marquee-clone', '');
      track.appendChild(clone);
    }

    groupWidth = sourceGroup.getBoundingClientRect().width;
    this.style.setProperty('--marquee-distance', `${-groupWidth}px`);

    for (const image of this.querySelectorAll('.logo-marquee__image')) {
      if (!image.complete) {
        image.addEventListener('load', this.#layout, { once: true });
      }
    }
  };

  #clearDynamicClones() {
    for (const clone of this.querySelectorAll('[data-marquee-clone]')) {
      clone.remove();
    }
  }
}

if (!customElements.get('logo-marquee-viewport')) {
  customElements.define('logo-marquee-viewport', LogoMarqueeViewport);
}
